module.exports = __webpack_public_path__ + "img/胜利.716e97a5.png";